import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { ITaskResponse, taskSearch, ITaskSearchParam } from 'wisestep-api';

import { useConversationWidgetStore } from '../../../utils/useConversationWidgetStore';

const useTaskSearch = (
  query: ITaskSearchParam,
  setLoader: Dispatch<SetStateAction<boolean>>
): [ITaskResponse[], number] => {
  const [taskList, setTaskList] = useState<ITaskResponse[]>([]);
  const taskFilterJobId = useConversationWidgetStore((state) => state.taskFilterJobId);
  const [totalsTasks, setCount] = useState(0);
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoader(true);
        if (taskFilterJobId && query.taskAttributes) {
          query.taskAttributes.jobCode = [taskFilterJobId];
        }
        const response = await taskSearch(query);
        setLoader(false);
        setTaskList(response.data);
        setCount(Number(response.headers['x-total-count']));
      } catch (e) {
        setLoader(false);
      }
    };

    fetchJobs();
  }, [query, setLoader, taskFilterJobId]);

  return [taskList, totalsTasks];
};

export default useTaskSearch;
